// API URLs
export const API_BASE_URL = "";
export const CDN_BASE_URL = "https://cdn.general-trucks.ru";

// API Endpoints
export const API_ENDPOINTS = {
  GET_GROUPS: "/api/get_groups/",
  GET_PRODUCTS: (categoryID) => `/api/get_products/${categoryID}/`,
  GET_PRODUCT: (product_id) => `/api/get_product/${product_id}/`,
  GET_PRODUCTS_FILTER: (filter) => `/api/get_products/filter/${filter}/`,
  GET_THUMBNAIL: (width, pictId) =>
    `${CDN_BASE_URL}/api/thumbnail/v2/${width}/${pictId}/`,
  GET_FILE: (fileId) => `${CDN_BASE_URL}/api/file/${fileId}/`,
};
